import { atom } from "recoil";

export const walletGroupsStore = atom({
	key: "walletGroupsStore",
	default: {
		loaded: false,
		data: [],
		currencies: [],
		currentSearch: "",
		error: { text: "", code: 0, timestamp: 0 },
		sorting: {
			sortingColumn: { order: "DESC", column: "id" },
			isDescending: true,
		},
		pagination: { current: 1, total: 0, count: 0 },
	},
});
